































































import { computed, defineComponent, PropType, toRefs } from "@vue/composition-api"
import { Info } from "../../config"
import { PopupType } from "../useAppleAuth"

export default defineComponent({
  name: "AppleAuth",
  props: {
    configInfo: {
      type: Object as PropType<Info>,
      required: true
    },
    isPhoneNumValid: {
      type: Boolean,
      required: true
    },
    phoneNum: {
      type: String,
      required: true
    },
    appleAuthErrorMsg: {
      type: String,
      required: true
    },
    appleAuthRetry: {
      type: Number,
      required: true
    },
    changePhoneNum: {
      // eslint-disable-next-line no-unused-vars
      type: Function as PropType<(e: any) => void>,
      required: true
    },
    goAppleAuth: {
      // eslint-disable-next-line no-unused-vars
      type: Function as PropType<(mobile: string) => Promise<void>>,
      required: true
    },
    retryAppleAuth: {
      type: Function as PropType<() => void>,
      required: true
    },
    showAppleAuth: {
      type: Function as PropType<() => void>,
      required: true
    },
    popupStatus: {
      type: String,
      required: true
    },
    closePopUp: {
      type: Function as PropType<() => void>,
      required: true
    }
  },
  setup(props) {
    const { popupStatus } = toRefs(props)
    const isAppleAuthShown = computed(() => popupStatus.value === PopupType.IS_APPLE_AUTH_SHOWN)
    const isPhoneInfoShown = computed(() => popupStatus.value === PopupType.IS_PHONE_INFO_SHOWN)
    const isAppleAuthErrorShown = computed(() => popupStatus.value === PopupType.IS_APPLE_AUTH_ERROR_SHOWN)

    return {
      isAppleAuthShown,
      isPhoneInfoShown,
      isAppleAuthErrorShown
    }
  }
})
